export function scannerTranslator() {
    const translations = [
        // Html5QrcodeStrings
        {original: "QR code parse error, error =", translation: "Ошибка при чтении QR-кода, ошибка ="},
        {original: "Error getting userMedia, error =", translation: "Ошибка получения доступа к камере, ошибка ="},
        {original: "The device doesn't support navigator.mediaDevices , only supported cameraIdOrConfig in this case is deviceId parameter (string).", translation: "Устройство не поддерживает navigator.mediaDevices, поддерживается только параметр deviceId (строка)."},
        {original: "Camera streaming not supported by the browser.", translation: "Браузер не поддерживает потоковое видео с камеры."},
        {original: "Unable to query supported devices, unknown error.", translation: "Не удалось получить список поддерживаемых устройств, неизвестная ошибка."},
        {original: "Camera access is only supported in secure context like https or localhost.", translation: "Доступ к камере поддерживается только в безопасном контексте (https или localhost)."},
        {original: "Scanner paused", translation: "Сканер приостановлен"},

        // Html5QrcodeScannerStrings
        {original: "Scanning", translation: "Сканирование"},
        {original: "Idle", translation: "Ожидание"},
        {original: "Error", translation: "Ошибка"},
        {original: "Permission", translation: "Разрешение"},
        {original: "No Cameras", translation: "Нет камер"},
        {original: "Last Match:", translation: "Последнее совпадение:"},
        {original: "Code Scanner", translation: "Сканер QR-кодов"},
        {original: "Request Camera Permissions", translation: "Запрос разрешения камеры"},
        {original: "Requesting camera permissions...", translation: "Запрос разрешения на использование камеры..."},
        {original: "No camera found", translation: "Камера не найдена"},
        {original: "Stop Scanning", translation: "Остановить сканирование"},
        {original: "Start Scanning", translation: "Начать сканирование"},
        {original: "Switch On Torch", translation: "Включить фонарик"},
        {original: "Switch Off Torch", translation: "Выключить фонарик"},
        {original: "Failed to turn on torch", translation: "Не удалось включить фонарик"},
        {original: "Failed to turn off torch", translation: "Не удалось выключить фонарик"},
        {original: "Launching Camera...", translation: "Запуск камеры..."},
        {original: "Scan an Image File", translation: "Сканировать изображение"},
        {original: "Scan using camera directly", translation: "Сканировать с помощью камеры"},
        {original: "Select Camera", translation: "Выбрать камеру"},
        {original: "Choose Image", translation: "Выбрать изображение"},
        {original: "Choose Another", translation: "Выбрать другое"},
        {original: "No image choosen", translation: "Изображение не выбрано"},
        {original: "Anonymous Camera", translation: "Неизвестная камера"},
        {original: "Or drop an image to scan", translation: "Или перетащите изображение для сканирования"},
        {original: "Or drop an image to scan (other files not supported)", translation: "Или перетащите изображение для сканирования (другие файлы не поддерживаются)"},
        {original: "zoom", translation: "масштаб"},
        {original: "Loading image...", translation: "Загрузка изображения..."},
        {original: "Camera based scan", translation: "Сканирование с камеры"},
        {original: "File based scan", translation: "Сканирование из файла"},

        // LibraryInfoStrings
        {original: "Powered by ", translation: "Работает на "},
        {original: "Report issues", translation: "Сообщить о проблеме"},

        // Others
        {original: "NotAllowedError: Permission denied", translation: "Ошибка: Доступ к камере запрещен"}
    ];

    // Function to translate text
    function translateText(text) {
        const translation = translations.find(t => t.original === text);
        return translation ? translation.translation : text;
    }

    // Function to translate text nodes
    function translateTextNodes(node) {
        if (node.nodeType === Node.TEXT_NODE) {
            const trimmedText = node.textContent.trim();
            if (trimmedText) {
                node.textContent = translateText(trimmedText);
            }
        } else {
            for (let i = 0; i < node.childNodes.length; i++) {
                translateTextNodes(node.childNodes[i]);
            }
        }
    }

    // Create MutationObserver
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach((node) => {
                    translateTextNodes(node);
                });
            }
        });
    });

    // Configure and start the observer
    const config = {childList: true, subtree: true};
    observer.observe(document.body, config);

    // Translate initial content
    translateTextNodes(document.body);
} 